







































































import Vue from 'vue';
import WeaponGrid from '@/components/smart/WeaponGrid.vue';
import {mapActions, mapGetters, mapState} from 'vuex';
import NftList, {NftIdType} from '@/components/smart/NftList.vue';
import { Quest, RewardType } from '@/interfaces';
import {
  Rarity,
  RequirementType,
  QuestTemplateType } from '@/enums/Quest';
import DustBalanceDisplay from '@/components/smart/DustBalanceDisplay.vue';
import NftIcon from '@/components/NftIcon.vue';
import {PropType} from 'vue/types/options';
import {Nft} from '../../interfaces/Nft';

interface StoreMappedActions {
  submitProgress(payload: { characterID: string | number, tokenIds: (string | number)[] }): Promise<void>;

  submitExternalProgress(payload: {
    characterID: string | number, tokenIds: (string | number)[], tokenAddress: string, questRequirementType: RequirementType }): Promise<void>;

  submitProgressAmount(payload: { characterID: string | number, amount: number }): Promise<void>;

  submitWalletProgressAmount(payload: { questID: number, amount: number }): Promise<void>;

  submitWalletProgress(payload: { questID: number, tokenIds: (string | number)[] }): Promise<void>;

  submitWalletExternalProgress(payload: {
    questID: number, tokenIds: (string | number)[], tokenAddress: string, questRequirementType: RequirementType }): Promise<void>;

  submitExternalProgressAmount(payload: { characterID: string | number, amount: number, currencyAddress: string }): Promise<void>;

  submitWalletExternalProgressAmount(payload: { questID: number, amount: number, currencyAddress: string }): Promise<void>;

  isExternalCurrency(payload: { currencyAddress: string }): Promise<boolean>;

  fetchGenesisSoulBalance(): Promise<number>;

  fetchExternalAvailableIds(payload: { tokenAddress: string, questId: number }): Promise<string[]>;
}

interface Data {
  quest?: Quest;
  characterId: number | string;
  questProgress: number;
  ownedTokens: string[];
  tokensToBurn: (string | number)[];
  externalsToBurn?: string;
  availableIds?: string;
  ownedNftIdTypes: NftIdType[];
  nftIdTypesToBurn: NftIdType[];
  amountToBurn: number;
  selectedToken?: number;
  isCurrency: boolean;
  isLoading: boolean;
  soulBalance: number;
}

export default Vue.extend({
  components: {WeaponGrid, NftList, DustBalanceDisplay, NftIcon},

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    character: {
      type: Object as PropType<Nft>,
    },
    quest: {
      type: Object as PropType<Quest>,
    },
    questTemplateType: {
      type: Number as PropType<QuestTemplateType>,
    },
  },

  data() {
    return {
      characterId: '',
      questProgress: 0,
      ownedTokens: [],
      tokensToBurn: [],
      externalsToBurn: undefined,
      availableIds: undefined,
      ownedNftIdTypes: [],
      nftIdTypesToBurn: [],
      amountToBurn: 0,
      selectedToken: undefined,
      isCurrency: false,
      isLoading: false,
      soulBalance: 0,
      RequirementType,
      RewardType,
      Rarity,
    } as Data;
  },


  computed: {
    ...mapState(['ownedWeaponIds', 'ownedTrinketIds', 'ownedJunkIds', 'ownedShieldIds']),
    ...mapGetters(['getPowerfulDust', 'getGreaterDust', 'getLesserDust', 'getCharacterStamina']),

    maxAmount(): number {
      if (!this.quest) return 0;
      if (this.quest.requirementType === RequirementType.DUST) {
        if (this.quest.requirementRarity === Rarity.COMMON) {
          return this.getLesserDust();
        } else if (this.quest.requirementRarity === Rarity.UNCOMMON) {
          return this.getGreaterDust();
        } else if (this.quest.requirementRarity === Rarity.RARE) {
          return this.getPowerfulDust();
        } else return 0;
      } else if (this.quest.requirementType === RequirementType.STAMINA) {
        return this.getCharacterStamina(this.characterId);
      } else if (this.quest.requirementType === RequirementType.SOUL) {
        return this.soulBalance;
      } else return 0;
    },

    getRequiredStars(): number {
      if (this.quest?.requirementRarity === undefined) return 0;
      return this.quest.requirementRarity + 1;
    },

    getRequiredStarsAndHigher(): number[] {
      return Array.from(Array(5 - this.getRequiredStars + 1).keys()).map(x => x + this.getRequiredStars);
    },
  },

  methods: {
    ...mapActions([
      'submitProgress',
      'submitProgressAmount',
      'submitWalletProgressAmount',
      'submitWalletProgress',
      'submitExternalProgress',
      'submitWalletExternalProgress',
      'submitExternalProgressAmount',
      'submitWalletExternalProgressAmount',
      'fetchGenesisSoulBalance',
      'fetchExternalAvailableIds',
      'isExternalCurrency',
    ]) as StoreMappedActions,

    upperFirstChar(text: string) {
      return text[0].toUpperCase() + text.slice(1).toLowerCase();
    },

    async isExternalCurrencyAddress() {
      if (!this.quest?.requirementExternalAddress) return false;
      this.isCurrency = await this.isExternalCurrency({currencyAddress: this.quest.requirementExternalAddress});
    },

    setRequiredAmount() {
      if (!this.quest) return;
      const remainingAmount = this.quest.requirementAmount - this.questProgress;
      if (this.quest.requirementType === RequirementType.STAMINA) {
        this.amountToBurn = remainingAmount > this.getCharacterStamina(this.characterId) ? this.getCharacterStamina(this.characterId) : remainingAmount;
      } else if (this.quest.requirementType === RequirementType.SOUL) {
        this.amountToBurn = remainingAmount > this.soulBalance ? this.soulBalance : remainingAmount;
      } else if (this.quest.requirementType === RequirementType.DUST) {
        if (this.quest.requirementRarity === Rarity.COMMON) {
          this.amountToBurn = remainingAmount > this.getLesserDust() ? this.getLesserDust() : remainingAmount;
        } else if (this.quest.requirementRarity === Rarity.UNCOMMON) {
          this.amountToBurn = remainingAmount > this.getGreaterDust() ? this.getGreaterDust() : remainingAmount;
        } else if (this.quest.requirementRarity === Rarity.RARE) {
          this.amountToBurn = remainingAmount > this.getPowerfulDust() ? this.getPowerfulDust() : remainingAmount;
        }
      } else if (this.quest.requirementType === RequirementType.EXTERNAL) {
        this.amountToBurn = remainingAmount;
      }
    },

    addBurnToken(id: number) {
      if (!this.quest) return;
      if (this.questProgress + this.tokensToBurn.length >= this.quest.requirementAmount) return;
      this.tokensToBurn.push(id.toString());
      this.ownedTokens = this.ownedTokens.filter(val => !this.tokensToBurn.includes(val.toString()));
      this.selectedToken = undefined;
    },

    removeBurnToken(id: number) {
      this.ownedTokens.push(id.toString());
      this.tokensToBurn = this.tokensToBurn.filter(x => x !== id.toString());
    },

    addNftIdType(nftIdType: NftIdType) {
      if (!this.quest) return;
      if (this.questProgress + this.tokensToBurn.length >= this.quest.requirementAmount) return;
      this.nftIdTypesToBurn.push(nftIdType);
      this.ownedNftIdTypes = this.ownedNftIdTypes.filter(val => !this.nftIdTypesToBurn.some(nftToBurn => nftToBurn.id === val.id));
      this.tokensToBurn = this.nftIdTypesToBurn.map(nftIdType => nftIdType.id);
      this.selectedToken = undefined;
    },

    removeNftIdType(nftIdType: NftIdType) {
      this.ownedNftIdTypes.push(nftIdType);
      this.nftIdTypesToBurn = this.nftIdTypesToBurn.filter(x => x.id !== nftIdType.id);
      this.tokensToBurn = this.nftIdTypesToBurn.map(nftIdType => nftIdType.id);
    },

    async submit() {
      try {
        this.isLoading = true;
        if(this.questTemplateType === QuestTemplateType.QUEST || this.questTemplateType === QuestTemplateType.PROMO){
          if (this.externalsToBurn && this.quest?.requirementExternalAddress &&
             (this.quest.requirementType === RequirementType.EXTERNAL || this.quest.requirementType === RequirementType.EXTERNAL_HOLD)) {
            await this.submitExternalProgress({
              characterID: this.characterId,
              tokenIds: this.externalsToBurn.split(',').map(id => +id),
              tokenAddress: this.quest.requirementExternalAddress,
              questRequirementType: this.quest.requirementType,
            });
          } else {
            await this.submitProgress({
              characterID: this.characterId,
              tokenIds: this.tokensToBurn,
            });
          }
        }
        else if(this.questTemplateType === QuestTemplateType.WALLET){
          if (this.externalsToBurn && this.quest?.requirementExternalAddress &&
             (this.quest.requirementType === RequirementType.EXTERNAL || this.quest.requirementType === RequirementType.EXTERNAL_HOLD)) {
            await this.submitWalletExternalProgress({
              questID: this.quest.id,
              tokenIds: this.externalsToBurn.split(',').map(id => +id),
              tokenAddress: this.quest.requirementExternalAddress,
              questRequirementType: this.quest.requirementType,
            });
          } else {
            await this.submitWalletProgress({
              questID: this.quest.id,
              tokenIds: this.tokensToBurn,
            });
          }
        }
      } finally {
        this.resetTokens();
        this.isLoading = false;
      }
    },

    async submitAmount() {
      if (!this.quest) return;
      try {
        this.isLoading = true;
        if(this.questTemplateType === QuestTemplateType.QUEST || this.questTemplateType === QuestTemplateType.PROMO){
          if (this.quest.requirementExternalAddress
            && (this.quest.requirementType === RequirementType.EXTERNAL || this.quest.requirementType === RequirementType.EXTERNAL_HOLD)) {
            await this.submitExternalProgressAmount({
              characterID: this.characterId,
              amount: this.amountToBurn,
              currencyAddress: this.quest.requirementExternalAddress,
            });
          } else {
            await this.submitProgressAmount({
              characterID: this.characterId,
              amount: this.amountToBurn,
            });
          }
        }
        else if(this.questTemplateType === QuestTemplateType.WALLET){
          if (this.quest.requirementExternalAddress
            && (this.quest.requirementType === RequirementType.EXTERNAL || this.quest.requirementType === RequirementType.EXTERNAL_HOLD)) {
            await this.submitWalletExternalProgressAmount({
              questID: this.quest.id,
              amount: this.amountToBurn,
              currencyAddress: this.quest.requirementExternalAddress,
            });
          } else {
            await this.submitWalletProgressAmount({
              questID: this.quest.id,
              amount: this.amountToBurn,
            });
          }
        }
      } finally {
        this.resetTokens();
        this.isLoading = false;
      }
    },

    resetTokens() {
      this.$emit('close-submission-modal');
      this.ownedTokens = [];
      this.ownedNftIdTypes = [];
      this.tokensToBurn = [];
      this.nftIdTypesToBurn = [];
      this.amountToBurn = 0;
    },

    isSubmitDisabled() {
      return !this.quest
        || (this.quest.requirementType === RequirementType.DUST && this.amountToBurn === 0)
        || (this.quest.requirementType === RequirementType.STAMINA && this.amountToBurn === 0)
        || (this.quest.requirementType === RequirementType.SOUL && this.amountToBurn === 0)
        || (this.quest.requirementType === RequirementType.WEAPON && this.tokensToBurn.length === 0)
        || (this.quest.requirementType !== RequirementType.DUST
          && this.quest.requirementType !== RequirementType.WEAPON
          && this.quest.requirementType !== RequirementType.STAMINA
          && this.quest.requirementType !== RequirementType.SOUL
          && this.quest.requirementType !== RequirementType.EXTERNAL
          && this.quest.requirementType !== RequirementType.EXTERNAL_HOLD
          && this.nftIdTypesToBurn.length === 0)
        || ((this.quest.requirementType === RequirementType.EXTERNAL
            || this.quest.requirementType === RequirementType.EXTERNAL_HOLD)
          && !this.externalsToBurn && !this.amountToBurn);
    }
  },

  watch: {
    async showModal(newVal: boolean) {
      if (newVal) {
        if(this.character){
          this.characterId = this.character.id;
        }
        this.questProgress = this.quest.progress;
        if (this.quest.requirementType === RequirementType.WEAPON) {
          this.ownedTokens = this.ownedWeaponIds;
        } else if (this.quest.requirementType === RequirementType.JUNK) {
          this.ownedTokens = this.ownedJunkIds;
          this.ownedJunkIds?.forEach((id: string) => this.ownedNftIdTypes.push({id, type: 'junk'}));
        } else if (this.quest.requirementType === RequirementType.TRINKET) {
          this.ownedTokens = this.ownedTrinketIds;
          this.ownedTrinketIds?.forEach((id: string) => this.ownedNftIdTypes.push({id, type: 'trinket'}));
        } else if (this.quest.requirementType === RequirementType.SHIELD) {
          this.ownedTokens = this.ownedShieldIds;
          this.ownedShieldIds?.forEach((id: string) => this.ownedNftIdTypes.push({id, type: 'shield'}));
        } else if (this.quest.requirementType === RequirementType.SOUL) {
          this.soulBalance = await this.fetchGenesisSoulBalance();
        } else if (this.quest.requirementType === RequirementType.EXTERNAL) {
          await this.isExternalCurrencyAddress();
        } else if (this.quest.requirementType === RequirementType.EXTERNAL_HOLD) {
          this.availableIds = String(await this.fetchExternalAvailableIds({
            tokenAddress: this.quest.requirementExternalAddress!,
            questId: this.quest.id
          }));
        }
      }
    }
  }
});
